import { g } from '../ability';

export default function defineOrgAdminAbilities(can) {
  can([g.VIEW], g.TEAM_MFA);
  can([g.EDIT], g.TEAM_MFA);
  can([g.PUBLISH], g.BILL_POSITION);
}
